import type { WorldPos } from "../core/types";

export interface DistrictDef {
  id: string;
  name: string;
  sub: string;
  pos: WorldPos;
  color: number;
  /** Escena de capítulo que abre (si está portada). */
  sceneKey?: string;
  /** Capítulo que hay que resolver antes de poder entrar aquí. */
  requires?: string;
}

/** La ciudad como HUB (puntos 7 y 25). Los 10 distritos son jugables: 6 de la
 *  historia principal (obras→fabrica→labo→torre→gris→central, encadenados por
 *  `requires`) y 4 casos extra independientes (poligono, bomberos, hospital, hotel). */
export const CITY_GRID = { w: 16, h: 12 };

export const DISTRICTS: DistrictDef[] = [
  { id: "obras", name: "Obras del Norte", sub: "Construcción", pos: { x: 3, y: 3 }, color: 0xdf5f2a, sceneKey: "obras" },
  { id: "fabrica", name: "Fábrica 13", sub: "Industria", pos: { x: 8, y: 2 }, color: 0x8a785a, sceneKey: "fabrica", requires: "obras" },
  { id: "labo", name: "Laboratorios Nova", sub: "Químico", pos: { x: 13, y: 3 }, color: 0x1c6b64, sceneKey: "labo", requires: "fabrica" },
  { id: "torre", name: "Torre Central", sub: "Oficinas", pos: { x: 8, y: 6 }, color: 0x3a5a8a, sceneKey: "torre", requires: "labo" },
  { id: "poligono", name: "Polígono Logístico", sub: "Almacén", pos: { x: 3, y: 8 }, color: 0xc9830a, sceneKey: "poligono" },
  { id: "bomberos", name: "Parque de Bomberos", sub: "Incendios", pos: { x: 11, y: 6 }, color: 0xc1442b, sceneKey: "bomberos" },
  { id: "hospital", name: "Hospital San EPI", sub: "Primeros auxilios", pos: { x: 3, y: 10 }, color: 0xb23a6a, sceneKey: "hospital" },
  { id: "central", name: "Central Eléctrica", sub: "Electricidad", pos: { x: 8, y: 10 }, color: 0xc9a20a, sceneKey: "central", requires: "gris" },
  { id: "gris", name: "Distrito Gris", sub: "Psicosocial", pos: { x: 13, y: 10 }, color: 0x6a6a72, sceneKey: "gris", requires: "torre" },
  { id: "hotel", name: "Hotel Mirador", sub: "Hostelería", pos: { x: 13, y: 7 }, color: 0xa83b2b, sceneKey: "hotel" },
];
